export const KITCHEN_PREP_WORKSHEET_LOADING = 'KITCHEN_PREP_WORKSHEET_LOADING';
export const KITCHEN_PREP_WORKSHEET_DATA = 'KITCHEN_PREP_WORKSHEET_DATA';
export const KITCHEN_PREP_WORKSHEET_FETCHING_ERROR =
  'KITCHEN_PREP_WORKSHEET_FETCHING_ERROR';
export const FETCH_WAREHOUSE_KITCHEN_LIST_LOADING =
  'FETCH_WAREHOUSE_KITCHEN_LIST_LOADING';
export const WAREHOUSE_KITCHEN_LIST_DATA = 'WAREHOUSE_KITCHEN_LIST_DATA';
export const FETCH_WAREHOUSE_KITCHEN_LIST_LOADING_ERROR =
  'FETCH_WAREHOUSE_KITCHEN_LIST_LOADING_ERROR';
export const SET_TO_DATE_MIN = 'SET_TO_DATE_MIN';
export const SET_FROM_DATE_MAX = 'SET_FROM_DATE_MAX';
export const CLEAR_KITCHEN_ERROR = 'CLEAR_KITCHEN_ERROR';
export const PRINT_KITCHEN_PREP_WORKSHEET_ERROR =
  'PRINT_KITCHEN_PREP_WORKSHEET_ERROR';
export const PRINT_KITCHEN_PREP_WORKSHEET_LOADING =
  'PRINT_KITCHEN_PREP_WORKSHEET_LOADING';
export const KITCHEN_PREP_WORKSHEET_CLOSE_LOADING =
  'KITCHEN_PREP_WORKSHEET_CLOSE_LOADING';
export const KITCHEN_PREP_WORKSHEET_CLOSE = 'KITCHEN_PREP_WORKSHEET_CLOSE';
export const KITCHEN_PREP_WORKSHEET_CLOSE_ERROR =
  'KITCHEN_PREP_WORKSHEET_CLOSE_ERROR';
export const PRINT_KITCHEN_PREP_WORKSHEET_DATA =
  'PRINT_KITCHEN_PREP_WORKSHEET_DATA';
export const CLEAR_PRINT_KITCHEN_PREP_WORKSHEET_DATA =
  'CLEAR_PRINT_KITCHEN_PREP_WORKSHEET_DATA';



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/kitchenPrepWorksheet/types.js